// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Hl7a","text":"SelectPayment_text__dOz9J","title":"SelectPayment_title__8y4_X","btn":"SelectPayment_btn__3mADv"};